"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("../Customer/OfficeFolder"), exports);
const classTransformer_1 = require("../classTransformer");
const OfficeFolder_1 = __importDefault(require("../Customer/OfficeFolder"));
const class_validator_1 = require("class-validator");
const User_1 = __importDefault(require("./User"));
const Deed_1 = __importDefault(require("./Deed"));
const Customer_1 = __importDefault(require("./Customer"));
const Document_1 = __importDefault(require("./Document"));
const Office_1 = __importDefault(require("./Office"));
const EFolderStatus_1 = __importDefault(require("../Customer/EFolderStatus"));
const OfficeFolderAnchor_1 = __importDefault(require("./OfficeFolderAnchor"));
const FolderSharing_1 = __importDefault(require("./FolderSharing"));
const Customer_2 = require("../Customer");
class OfficeFolder extends OfficeFolder_1.default {
    constructor() {
        super(...arguments);
        this.description = null;
        this.archived_description = null;
        this.status = EFolderStatus_1.default.LIVE;
        this.folder_anchor = null;
    }
}
exports.default = OfficeFolder;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createDocument"], message: "UID is required" }),
    __metadata("design:type", String)
], OfficeFolder.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.NotEquals)("", {
        groups: ["updateFolder"],
        message: "Numéro de dossier ne peut pas être vide",
    }),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createFolder"],
        message: "Numéro de dossier ne peut pas être vide",
    }),
    __metadata("design:type", String)
], OfficeFolder.prototype, "folder_number", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.NotEquals)("", {
        groups: ["updateFolder"],
        message: "Nom de dossier ne peut pas être vide",
    }),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createFolder"],
        message: "Nom de dossier ne peut pas être vide",
    }),
    __metadata("design:type", String)
], OfficeFolder.prototype, "name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "archived_description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", String)
], OfficeFolder.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archive_status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archive_started_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archived_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createFolder", "updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "long_term_archive_last_error", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createFolder"], message: "Office is required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["createFolder"] }),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], OfficeFolder.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createFolder"], message: "Deed type is required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["createFolder"] }),
    (0, classTransformer_1.Type)(() => Deed_1.default),
    __metadata("design:type", Deed_1.default)
], OfficeFolder.prototype, "deed", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createFolder"],
        message: "Au moins un collaborateur est requis",
    }),
    (0, class_validator_1.NotEquals)([], {
        groups: ["updateFolder", "createFolder"],
        message: "Au moins un collaborateur est requis",
    }),
    (0, class_validator_1.ValidateNested)({ groups: ["createFolder", "updateFolder"] }),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "stakeholders", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.ValidateNested)({ groups: ["updateFolder"] }),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "customers", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.ValidateNested)({ groups: ["updateFolder"] }),
    (0, classTransformer_1.Type)(() => Document_1.default),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "documents", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.ValidateNested)({ groups: ["updateFolder"] }),
    (0, classTransformer_1.Type)(() => OfficeFolderAnchor_1.default),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "folder_anchor", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Customer_2.Note),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "notes", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.ValidateNested)({ each: true, groups: ["updateFolder"] }),
    (0, classTransformer_1.Type)(() => FolderSharing_1.default),
    __metadata("design:type", Array)
], OfficeFolder.prototype, "folder_sharings", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.ValidateNested)({ groups: ["updateFolder"] }),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", User_1.default)
], OfficeFolder.prototype, "created_by", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "main_contact_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateFolder"] }),
    (0, class_validator_1.ValidateNested)({ groups: ["updateFolder"] }),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", Object)
], OfficeFolder.prototype, "main_contact", void 0);
